export default "__VITE_ASSET__DlryWnE5__"